import { ref, onMounted } from 'vue'

const API_BASE = import.meta.env.VITE_API_BASE || ''

export function useVisitorCount() {
  const count = ref(0)
  const loading = ref(false)
  const error = ref(null)

  // 获取当前访问次数
  async function fetchCount() {
    try {
      const res = await fetch(`${API_BASE}/api/stats`)
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      if (data.success) {
        count.value = data.visitCount || 0
      }
    } catch (e) {
      console.error('[VisitorCount] Fetch error:', e)
      // 失败时使用本地存储作为降级
      const localCount = localStorage.getItem('visitor_count_backup')
      count.value = localCount ? parseInt(localCount) : 1000
    }
  }

  // 增加访问次数（真实后端计数）
  async function incrementCount() {
    // 检查本次会话是否已计数
    const sessionCounted = sessionStorage.getItem('visit_counted')
    if (sessionCounted) return

    try {
      const res = await fetch(`${API_BASE}/api/stats/visit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      if (data.success) {
        count.value = data.visitCount
        localStorage.setItem('visitor_count_backup', data.visitCount)
      }
      // 标记本次会话已计数
      sessionStorage.setItem('visit_counted', 'true')
    } catch (e) {
      console.error('[VisitorCount] Increment error:', e)
      // 失败时使用本地降级
      const localCount = parseInt(localStorage.getItem('visitor_count_backup') || '1000')
      count.value = localCount + 1
      localStorage.setItem('visitor_count_backup', count.value)
      sessionStorage.setItem('visit_counted', 'true')
    }
  }

  // 记录下载
  async function recordDownload() {
    try {
      await fetch(`${API_BASE}/api/stats/download`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
    } catch (e) {
      console.error('[VisitorCount] Download record error:', e)
    }
  }

  onMounted(() => {
    // 先获取当前计数
    fetchCount().then(() => {
      // 然后尝试增加计数（新访客）
      incrementCount()
    })
  })

  return {
    count,
    loading,
    error,
    fetchCount,
    incrementCount,
    recordDownload
  }
}
